import type { AxiosInstance } from 'axios';
import { transformPropertyConfig, transformPropertyConfigs } from '../transforms/property-config';
import { PropertyConfigModel, TaskConfigModel } from '@/models/property-config';
import { PropertyConfig } from '../types/property-config';

class PropertyConfigService {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getTaskConfigs(propertyId: string): Promise<PropertyConfigModel[]> {

    const response = await this.client.get<PropertyConfig[]>('/property-config', {
      params: {
        type: 'task',
        propertyId,
        '$sort[key]': 1,
      }
    });

    return transformPropertyConfigs(response.data.data);
  }

  async togglePropertyConfig(propertyConfigId: string, isActive: boolean): Promise<PropertyConfigModel> {

    const response = await this.client.patch<PropertyConfig>(`/property-config/${propertyConfigId}`, {
      isActive,
    });

    return transformPropertyConfig(response.data);
  }

  async updateTaskConfig(propertyConfigId: string, taskConfig: TaskConfigModel) {
    const response = await this.client.patch<PropertyConfig>(`/property-config/${propertyConfigId}`, {
      config: taskConfig,
    });

    return transformPropertyConfig(response.data);
  }
}

export { PropertyConfigService };
